import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react-lite";
import useCurrentUserData from "../../../../hooks/useCurrentUserData";
import models from "../../../../types/models";

export default observer(function CardTitle({ countCard, card, i }) {
  CardTitle.propTypes = {
    countCard: PropTypes.number,
    i: PropTypes.number,
    card: PropTypes.oneOfType([models.gameCard, models.compromiseGameCard]),
  };
  const { getUserData } = useCurrentUserData();
  const user = getUserData();
  return (
    <div className="in-game-page__main__swipe-wrapper__wrapper__question">
      {i === countCard && card?.question}
      {i === countCard && user?.gender === "male"
        ? card?.question_for_male
        : i === countCard && user?.gender === "female"
        ? card?.question_for_female
        : card?.question_for_male}
    </div>
  );
});
